import Vue from 'vue';
import './plugins/bootstrap-vue';
import axios from "axios";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import router from './router';
import store from './store';
import App from './App.vue';

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_SITE_API_URL;
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app')
